var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 184 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7598 0C67.4236 0.000161138 44.0842 8.05256 26.876 22.3859C9.66773 36.7192 0.000164871 56.1593 0 76.4297C0.0221775 89.6145 4.13895 102.57 11.9502 114.038C19.7615 125.506 31.0016 135.095 44.5781 141.875C40.9622 149.97 35.539 157.561 28.5332 164.334C42.1191 161.949 54.8726 156.939 65.8008 149.693C74.2271 151.779 82.9694 152.845 91.7598 152.859C116.096 152.859 139.435 144.807 156.644 130.473C173.852 116.14 183.519 96.7 183.52 76.4297C183.519 56.1593 173.852 36.7192 156.644 22.3859C139.435 8.05256 116.096 0.000160387 91.7598 0Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messages-icon.16f5f4caee91560f13e0190f126d6c43.svg";
export { ForwardRef as ReactComponent };